export enum ECookieNames {
  AccessToken = 'externalAssistance_accessToken',
}
